const GtmEventDataModule = {
  namespaced: true,
  state: {
    tariffName: null,
    tariffProductNumber: null,
    tariffPrice: null,
    tariffShippingCosts: null
  },
  actions: {},
  mutations: {
    storeTariffName (state, name) {
      state.tariffName = name
    },
    storeTariffProductNumber (state, productNumber) {
      state.tariffProductNumber = productNumber
    },
    storeTariffPrice (state, price) {
      state.tariffPrice = price
    },
    storeTariffShippingCosts (state, shippingCosts) {
      state.tariffShippingCosts = shippingCosts
    }
  },
  getters: {
    friendState: state => state.friendState,
    showReferFriend: state => state.showReferFriend,
    getTariffName: state => {
      return state.tariffName
    },
    getTariffProductNumber: state => state.tariffProductNumber,
    getTariffPrice: state => state.tariffPrice,
    getTariffShippingCosts: state => {
      return state.tariffShippingCosts
    }
  }
}

export default GtmEventDataModule
